export enum SolidSurfaceConfigLayout {
    SINGLE = 'single',
    GALLEY = 'galley',
    L_SHAPED = 'lshaped',
    U_SHAPED = 'ushaped',
    G_SHAPED = 'gshaped',
    ISLAND = 'island'
}
